module.exports = __webpack_public_path__ + "img/platforminfo.58b871c3.png";